import React, { useContext, useEffect, useState } from "react";
import { Check } from "react-feather";
import { ReactComponent as BELL } from "../../../assets/icons/bell.svg";
import PopUpModal from "../../../NewComponents/PopUpModal";

import { DataContext } from "../../../Context/DataContext";
import { AuthContext } from "../../../Context/AuthContext";
import { NotificationContext } from "../../../Context/NotificationContext";
import { firestore } from "../../../firebase.config";

const Notifications = () => {
    const { userData, teamData } = useContext(DataContext);
    const { showNotification } = useContext(NotificationContext);
    const { signedIn } = useContext(AuthContext);
    const [orderCreated, setOrderCreated] = useState(false);
    const [orderCompleted, setOrderCompleted] = useState(false);
    const [orderNewMessage, setOrderNewMessage] = useState(false);
    const [orderAbandoned, setAbandoned] = useState(false);

    // const [orderNewComment, setOrderNewComment] = useState(false);

    const [quoteCreated, setQuoteCreated] = useState(false);
    const [quoteReviewed, setQuoteReviewed] = useState(false);

    const [quoteNewMessage, setQuoteNewMessage] = useState(false);

       const [disableAll, setDisableAll] = useState(false);
    const [showDisableAll, setShowDisableAll] = useState(false);
    const [disableBtnText, setDisableBtnText] = useState("Disable All");

    const [issuedInvoices, setIssuedInvoices] = useState(false);

    useEffect(() => {
        if (signedIn && userData) {

            if (userData.id && !userData.disabledNotifications) {
                firestore.collection("users").doc(userData.id).update({
                    disabledNotifications: {
                        orderCreated: false,
                        orderCompleted: false,
                        orderNewMessage: false,
                        orderAbandoned:false,
                        // orderNewComment: false,
                        quoteCreated: false,
                        quoteReviewed: false,
                        // quoteOrdered: false,
                        // quoteNewComment: false,
                        quoteNewMessage: false,
                        disableAll: false,
                    }
                })
            }
            if (userData.teamId && teamData && !teamData.disabledNotifications && teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
                firestore.collection("teams").doc(userData.teamId).update({
                    disabledNotifications: {
                        invoiceIssue: false,
                    }
                })
            }
            

        }

    }, [signedIn, userData, teamData,disableAll]);

    useEffect(() => {
        if (signedIn && userData) {
            const userNotifications = userData.disabledNotifications || {};
            
    
            setOrderCompleted(userNotifications.orderCompleted ?? false);
            setOrderCreated(userNotifications.orderCreated ?? false);
            setOrderNewMessage(userNotifications.orderNewMessage ?? false);
            setAbandoned(userNotifications.orderAbandoned ?? false);

            // setOrderNewComment(userNotifications.orderNewComment ?? false);
            setQuoteCreated(userNotifications.quoteCreated ?? false);
            setQuoteReviewed(userNotifications.quoteReviewed ?? false);
            setQuoteNewMessage(userNotifications.quoteNewMessage ?? false);
            setDisableAll(userNotifications.disableAll ?? false);

            if(userData.teamId && teamData.billingTerm && teamData.billingTerm !== "case-by-case"){
                const teamNotifications = teamData?.disabledNotifications || {};
                setIssuedInvoices(teamNotifications.invoiceIssue ?? false);
            }
    
           
        }
    }, [signedIn, userData, teamData,disableAll]);
    

    const handleCheck = (setState, state, selectedBox, isteam = false) => {
    
        if (!userData || (isteam && !teamData)) {
            showNotification("Error", "User or team data is not available.", "error");
            return;
        }
    
        // Ensure notifications object exists
        const userNotifications = userData.disabledNotifications || {};
        const teamNotifications = teamData?.disabledNotifications || {};
    
        const notifications = isteam
            ? { ...teamNotifications, [selectedBox]: !state,}
            : { ...userNotifications, [selectedBox]: !state, disableAll: !state ? false : userNotifications.disableAll };
    
        firestore
            .collection(isteam ? "teams" : "users")
            .doc(isteam ? userData.teamId : userData.id)
            .update({
                disabledNotifications: notifications,
            })
            .then(() => {
                setState(!state);
            })
            .catch((e) => {
                console.error(e);
                showNotification("Error", "An error occurred while updating notification settings.", "error");
            });
    };
    

    const handleDisableAll = async () => {
        setDisableBtnText("Disabling...");
    
        const disableNotificationsTemplate = {
            disableAll: true,
            orderCompleted: true,
            orderCreated: true,
            // orderNewComment: true,
            orderNewMessage: true,
            orderAbandoned:true,
            quoteCreated: true,
            quoteNewMessage: true,
            quoteReviewed: true,
            // quoteNewComment: true,
            // quoteOrdered: true,
        };
    
        try {
            await firestore.collection("users").doc(userData.id).update({
                disabledNotifications: disableNotificationsTemplate,
            });
            if (userData.teamId && teamData && !teamData.disabledNotifications && teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
                firestore.collection("teams").doc(userData.teamId).update({
                    disabledNotifications: {
                        invoiceIssue: true,
                    }
                })
            }
            setOrderCompleted(true);
            setOrderCreated(true);
            setAbandoned(true);
            setOrderNewMessage(true);
            // setOrderNewComment(true);
            setQuoteCreated(true);
            setQuoteReviewed(true);
            setQuoteNewMessage(true);
            setDisableAll(true); 
    
            
        } catch (e) {
            console.error(e);
            showNotification("Error", "An error occurred while processing the request. Please try again.", "error");
        } finally {
            setShowDisableAll(false);
            setDisableBtnText("Disable All");
        }
    };
    

    const checkDisableAll = () => {
     
            return disableAll
        
    }


    return <>
        {showDisableAll && <PopUpModal title={"Disable All Notifications"} backBtnText="Back to Notifications" subText="Are you sure you want to disable all notifications?" text={""} btnText={disableBtnText}
            iconBgColor="#FFF6EA" deleteBtn={true} showClose onClose={() => setShowDisableAll(false)} onClick={handleDisableAll} onBackClick={() => setShowDisableAll(false)} disableBtn={disableBtnText === "Disabling..."}>
            <BELL />
        </PopUpModal>}
        <div className="accountSettingShippingWrap">
            <h4 className="accountSettingNotificationTitle">Email Notification</h4>

            {/* Orders */}
            <div className="accountSettingNotificationOptionsWrap">
                <h5 className="accountSettingNotificationOptionsTitle">Orders</h5>
                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setOrderCreated, orderCreated, "orderCreated") }}>
                        <div className={`${!orderCreated && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !orderCreated ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">An order has been created</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Order #64820 Confirmed – Thank You!</p>
                </div>
                <div className="accountSettingNotificationDivider" />
                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setOrderCompleted, orderCompleted, "orderCompleted") }}>
                        <div className={`${!orderCompleted && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !orderCompleted ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">An order has been completed</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Your Order #64820 Is Ready!</p>
                </div>
                <div className="accountSettingNotificationDivider" />

                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setOrderNewMessage, orderNewMessage, "orderNewMessage") }}>
                        <div className={`${!orderNewMessage && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !orderNewMessage ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">Order has a new message</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">New Message About Your Order #64820</p>
                </div>
                <div className="accountSettingNotificationDivider" />

                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setAbandoned, orderAbandoned, "orderAbandoned") }}>
                        <div className={`${!orderAbandoned && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !orderAbandoned ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">An order has been started but abandoned</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Complete Your Order #64820</p>
                </div>
                <div className="accountSettingNotificationDivider" />

                {/* <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setOrderNewComment, orderNewComment, "orderNewComment") }}>
                        <div className={`${orderNewComment && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: orderNewComment ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">File in the order has a new comment</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">New comment in a file in Order #234...</p>
                </div> */}
            </div>

            {/* Quotes */}
            <div className="accountSettingNotificationOptionsWrap">
                <h5 className="accountSettingNotificationOptionsTitle">Quotes</h5>
                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setQuoteCreated, quoteCreated, "quoteCreated") }}>
                        <div className={`${!quoteCreated && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !quoteCreated ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">A quote has been created</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Quote #43200 Has Been Received!</p>
                </div>
                <div className="accountSettingNotificationDivider" />
                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setQuoteReviewed, quoteReviewed, "quoteReviewed") }}>
                        <div className={`${!quoteReviewed && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !quoteReviewed ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">A quote has been reviewed</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Your Quote #43200 Is Ready!</p>
                </div>
                <div className="accountSettingNotificationDivider" />

                
      

                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setQuoteNewMessage, quoteNewMessage, "quoteNewMessage") }}>
                        <div className={`${!quoteNewMessage && "hardCopyChecked"} hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: !quoteNewMessage ? 1 : 0 }} />
                        </div>
                        <p className="hardCopyCheckboxText">Quote has a new message</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">New Message About Your Quote #43200</p>
                </div>
                
            </div>

            {userData && userData.teamId && <div className="accountSettingNotificationOptionsWrap">
                <h5 className="accountSettingNotificationOptionsTitle">Invoices</h5>
                <div className="accountSettingCheckboxLineWrap">
                    <div className="accountSettingCheckboxLine" >
                        <div className={` bg-[#9A9FA7] border-[#9A9FA7] opacity-50 hardCopyCheckbox`}>
                            <Check className="hardCopyCheck" style={{ opacity: 1 }} />
                        </div>
                        <p className="hardCopyCheckboxText">Overdue Payments</p>
                    </div>
                    <p className="accountSettingCheckboxSubText">Complete Payment for Your Order #84320 (5 Days Overdue)</p>
                </div>
                {teamData?.billingTerm && teamData?.billingTerm !== "case-by-case" &&
                    <>
                        <div className="accountSettingNotificationDivider" />

                        <div className="accountSettingCheckboxLineWrap">
                            <div className="accountSettingCheckboxLine" onClick={() => { handleCheck(setIssuedInvoices, issuedInvoices, "Invoice", true) }} >
                                <div className={`${!issuedInvoices && "hardCopyChecked"} hardCopyCheckbox`}>
                                    <Check className="hardCopyCheck" style={{ opacity: !issuedInvoices ? 1 : 0 }} />
                                </div>
                                <p className="hardCopyCheckboxText">An invoice has been issued</p>
                            </div>
                            <p className="accountSettingCheckboxSubText">Invoice #234... ready!</p>
                        </div>
                    </>
                }

            </div>}

            <div className="accountSettingCheckboxLine accountSettingNotificationDisableAll" onClick={() => { checkDisableAll() ? setDisableAll(false) : setShowDisableAll(true) }}>
                <div className={`${checkDisableAll() && "hardCopyChecked"} hardCopyCheckbox`}>
                    <Check className="hardCopyCheck" style={{ opacity: checkDisableAll() ? 1 : 0 }} />
                </div>
                <p className="hardCopyCheckboxText">Disable all</p>
            </div>


        </div>
    </>;
};

export default Notifications;
